/* eslint-disable import/no-anonymous-default-export */

import ProductActionTypes from "./product.types";
import { docodeHexResponse } from "../../_common/common.utils";

const INITIAL_STATE = {
  addProductDetailsResponse: null,
  updateProductDetailsResponse: null,
  getProductListResponse: null,
  getProductListArr: [],
  fetchProductDetailsResponse: null,
  fetchProductDetailsArr: [],
  deleteProductDetailsResponse: null,
  deleteProductQuestionResponse: null,
};

export default (state = INITIAL_STATE, action: any) => {
  switch (action.type) {
    /** ***************** ADD PRODUCT DETAILS START *********************** */
    case ProductActionTypes.ADD_PRODUCT_DETAILS_SUCCESS:
      return { ...state, addProductDetailsResponse: action.payload };

    case ProductActionTypes.ADD_PRODUCT_DETAILS_FAILURE:
      return { ...state, addProductDetailsResponse: action.payload };

    case ProductActionTypes.ADD_PRODUCT_DETAILS_RESPONSE_CHANGED:
      return { ...state, addProductDetailsResponse: null };
    /** ***************** ADD PRODUCT DETAILS END *********************** */

    /** ***************** UPDATE PRODUCT DETAILS START *********************** */
    case ProductActionTypes.UPDATE_PRODUCT_DETAILS_SUCCESS:
      return { ...state, updateProductDetailsResponse: action.payload };

    case ProductActionTypes.UPDATE_PRODUCT_DETAILS_FAILURE:
      return { ...state, updateProductDetailsResponse: action.payload };

    case ProductActionTypes.UPDATE_PRODUCT_DETAILS_RESPONSE_CHANGED:
      return { ...state, updateProductDetailsResponse: null };
    /** ***************** UPDATE PRODUCT DETAILS END *********************** */

    /** ***************** GET PRODUCT DETAILS START *********************** */
    case ProductActionTypes.GET_PRODUCT_LIST_SUCCESS:
      return {
        ...state,
        getProductListResponse: action.payload,
        getProductListArr: docodeHexResponse(
          action.payload,
          "GetAllProductPaginationKey",
        ),
      };

    case ProductActionTypes.GET_PRODUCT_LIST_FAILURE:
      return {
        ...state,
        getProductListResponse: action.payload,
        getProductListArr: [],
      };

    case ProductActionTypes.GET_PRODUCT_LIST_RESPONSE_CHANGED:
      return { ...state, getProductListResponse: null };
    /** ***************** GET PRODUCT DETAILS END *********************** */

    /** ***************** FETCH PRODUCT DETAILS START *********************** */
    case ProductActionTypes.FETCH_PRODUCT_DETAILS_SUCCESS:
      return {
        ...state,
        fetchProductDetailsResponse: action.payload,
        fetchProductDetailsArr: docodeHexResponse(
          action.payload,
          "FetchProductKey",
        ),
      };

    case ProductActionTypes.FETCH_PRODUCT_DETAILS_FAILURE:
      return { ...state, fetchProductDetailsResponse: action.payload };

    case ProductActionTypes.FETCH_PRODUCT_DETAILS_RESPONSE_CHANGED:
      return {
        ...state,
        fetchProductDetailsResponse: null,
        fetchProductDetailsArr: [],
      };
    /** ***************** FETCH PRODUCT DETAILS END *********************** */

    /** ***************** DELETE PRODUCT DETAILS START *********************** */
    case ProductActionTypes.DELETE_PRODUCT_DETAILS_SUCCESS:
      return { ...state, deleteProductDetailsResponse: action.payload };

    case ProductActionTypes.DELETE_PRODUCT_DETAILS_FAILURE:
      return { ...state, deleteProductDetailsResponse: action.payload };

    case ProductActionTypes.DELETE_PRODUCT_DETAILS_RESPONSE_CHANGED:
      return { ...state, deleteProductDetailsResponse: null };
    /** ***************** DELETE PRODUCT DETAILS END *********************** */

    /** ***************** DELETE PRODUCT QUESTION START *********************** */
    case ProductActionTypes.DELETE_PRODUCT_QUESTION_SUCCESS:
      return { ...state, deleteProductQuestionResponse: action.payload };

    case ProductActionTypes.DELETE_PRODUCT_QUESTION_FAILURE:
      return { ...state, deleteProductQuestionResponse: action.payload };

    case ProductActionTypes.DELETE_PRODUCT_QUESTION_RESPONSE_CHANGED:
      return { ...state, deleteProductQuestionResponse: null };
    /** ***************** DELETE PRODUCT QUESTION END *********************** */

    default:
      return state;
  }
};
